import { createStyles, makeStyles } from '@material-ui/core';
import { theme } from '@saesa/ui-kit-front';

const HeaderMapaStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'absolute',
      top: '24px',
      left: '48px',
      right: '48px',
      zIndex: 4,
      display: 'flex',
      justifyContent: 'flex-start',
      pointerEvents: 'none',
      [theme.breakpoints.down('sm')]: {
        top: '16px',
        left: 0,
        right: 0,
        justifyContent: 'center',
      },
    },
    barra: {
      pointerEvents: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: '48px',
      backgroundColor: 'var(--blanco)',
      borderRadius: '20px',
      padding: '10px 24px',
      boxShadow: '0px 2px 15px rgba(9, 39, 84, 0.14)',
      [theme.breakpoints.down('sm')]: {
        gap: 0,
        padding: 0,
        backgroundColor: 'transparent',
        boxShadow: 'none',
        borderRadius: 0,
      },
    },
    logo: {
      height: '35px',
      width: 'auto',
      display: 'block',
    },
    logoLink: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
    },
    legendCnt: {
      display: 'flex',
      alignItems: 'center',
      gap: '24px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    legendGrupo: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    legendTitulo: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#060709',
      whiteSpace: 'nowrap',
    },
    legendItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    legendDot: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      flexShrink: 0,
    },
    dotInesperado: {
      backgroundColor: '#CB0126',
    },
    dotProgramado: {
      backgroundColor: '#E08A00',
    },
    dotFuturos: {
      backgroundColor: '#0285BF',
    },
    legendTexto: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#060709',
      whiteSpace: 'nowrap',
    },
    legendTextoMuted: {
      color: '#9196B1',
    },
    separador: {
      width: '1px',
      height: '12px',
      backgroundColor: '#CCCFDB',
    },
    futurosCnt: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    botonReportar: {
      pointerEvents: 'auto',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#4F1FFF',
      border: '2px solid #4F1FFF',
      backgroundColor: 'var(--blanco)',
      borderRadius: '26px',
      cursor: 'pointer',
      height: '45px',
      padding: '0 32px',
      textTransform: 'none',
      fontFamily: 'Neutrif Studio',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '18px',
      boxShadow: 'none',
      whiteSpace: 'nowrap',
      '&:hover': {
        backgroundColor: '#F7F5FF',
        border: '2px solid #4F1FFF',
        color: '#4F1FFF',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    fabsMobile: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        position: 'absolute',
        top: '64px',
        left: '16px',
        zIndex: 4,
        pointerEvents: 'auto',
      },
    },
    fab: {
      width: '48px',
      height: '48px',
      borderRadius: '24px',
      backgroundColor: 'var(--blanco)',
      boxShadow: '0px 2px 6px rgba(9, 39, 84, 0.14)',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
    },
    panelMobile: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        top: '120px',
        left: '16px',
        right: '16px',
        zIndex: 5,
        backgroundColor: 'var(--blanco)',
        borderRadius: '20px',
        boxShadow: '0px 2px 15px rgba(9, 39, 84, 0.14)',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        pointerEvents: 'auto',
      },
    },
    panelMobileRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '12px',
    },
    botonReportarMobile: {
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#4F1FFF',
      border: '2px solid #4F1FFF',
      backgroundColor: 'var(--blanco)',
      borderRadius: '26px',
      cursor: 'pointer',
      height: '45px',
      textTransform: 'none',
      fontFamily: 'Neutrif Studio',
      fontWeight: 600,
      fontSize: '14px',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#F7F5FF',
        border: '2px solid #4F1FFF',
        color: '#4F1FFF',
      },
    },
    dotsLegend: {
      display: 'flex',
      gap: '4px',
      alignItems: 'center',
    },
  })
);

export default HeaderMapaStyles;
